import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { ApiKeysState } from './apiKeys.types';

// Base selector
const selectApiKeysState = (state: RootState): ApiKeysState => state.apiKeys;

// Data selectors
export const selectApiKey = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.apiKey
);

export const selectGeneratedKey = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.generatedKey
);

// Loading selectors
export const selectApiKeysLoading = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.loading
);

export const selectGenerateApiKeyLoading = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.generateLoading
);

export const selectFetchApiKeyLoading = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.fetchLoading
);

// Error selectors
export const selectApiKeysError = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.error
);

export const selectGenerateApiKeyError = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.generateError
);

export const selectFetchApiKeyError = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.fetchError
);

// Success selectors
export const selectApiKeysSuccess = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.success
);

export const selectGenerateApiKeySuccess = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.generateSuccess
);

export const selectFetchApiKeySuccess = createSelector(
  [selectApiKeysState],
  (apiKeysState) => apiKeysState.fetchSuccess
); 